import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BlogService } from 'src/app/_services/blog.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BlogPost } from 'src/app/_models/blog-post';
import { IPagination } from 'src/app/_models/pagination';
import { environment } from 'src/environments/environment';
import { User } from 'src/app/_models/user';

@Component({
    selector: 'app-blog',
    templateUrl: './blog.component.html',
    styleUrls: ['./blog.component.css'],
    standalone: false
})
export class BlogComponent implements OnInit {
  title = 'Blog';
  page = '1';
  blogPosts: BlogPost[] = [];
  loading = true;
  config: any;
  user: User = null;

  categories: any[] = [];
  selectedCategorySlug: string | null = null;
  selectedCategoryName: string | null = null;

  constructor(
    private titleService: Title,
    private blogService: BlogService,
    private router: Router,
    private activeRoute: ActivatedRoute
  ) {
    this.user = JSON.parse(localStorage.getItem('currentUser') ?? '{}');
    this.titleService.setTitle(this.title);
    const p = this.activeRoute.snapshot.queryParamMap.get('page');
    if (p !== null) {
      this.page = p;
    }
  }

  ngOnInit() {
    const categorySlug = this.activeRoute.snapshot.paramMap.get('categorySlug');
    if (categorySlug) {
      this.selectedCategorySlug = categorySlug;
    }
    this.loadCategories();
    this.loadBlog();
    window.scrollTo(0, 0);
  }

  loadCategories() {
    this.blogService.loadBlogCategories().subscribe(
      (categories: any[]) => {
        this.categories = categories || [];
      },
      () => {
        this.categories = [];
      }
    );
  }

  loadBlog() {
    this.loading = true;
    if (this.selectedCategorySlug) {
      this.blogService.loadBlogsByCategory(this.selectedCategorySlug, parseInt(this.page, 10), 10).subscribe(
        (result: any) => this.setConfig(result),
        null,
        () => this.loading = false
      );
    } else {
      this.blogService.loadBlog(this.page).subscribe(
        (iPagination: IPagination) => this.setConfig(iPagination),
        null,
        () => this.loading = false
      );
    }
  }

  selectCategory(slug: string | null, name: string | null) {
    this.selectedCategorySlug = slug;
    this.selectedCategoryName = name;
    this.page = '1';
    if (slug) {
      this.router.navigate(['/blog/category', slug]);
    } else {
      this.router.navigate(['/blog']);
    }
    this.loadBlog();
  }

  hasImagePath(blog) {
    return blog.imagePath !== '' && blog.imagePath != null && blog.imagePath.includes('media');
  }

  getImageSrc(imagePath) {
    return imagePath !== '' && imagePath !== null && imagePath.includes('media') ?
    environment.image_cdn_url + '/' + imagePath : '/assets/images/blog-img1_1.jpg';
  }

  pageChange(page) {
    this.page = page;
    if (this.selectedCategorySlug) {
      this.router.navigate(['/blog/category', this.selectedCategorySlug], { queryParams: { page } });
    } else {
      this.router.navigate(['/blog'], { queryParams: { page } });
    }
    this.loadBlog();
    window.scrollTo(0, 0);
  }

  private setConfig(result: any) {
    this.blogPosts = result.data;
    this.config = {
        currentPage: result.page,
        itemsPerPage: result.itemPerPage,
        totalItems: result.totalOfItems,
        totalOfPage: result.totalOfPage,
        id: 'listing'
    };
  }

  trimHTMLTags(content: string) {
    return content.replace(/(<([^>]+)>)/ig, '');
  }
}
